import * as React from 'react'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core'

import IconColourClass from './IconColourClass'

interface FontAwesomeIconProps {
  icon: IconProp
  size?: SizeProp
  colour?: Icon.Colour
}

const FontAwesomeIcon = (props: FontAwesomeIconProps) => {
  const { icon, size, colour } = props

  const iconColour: IconColourClass = IconColourClass[colour as keyof typeof IconColourClass]

  return (
    <span className={iconColour}>
      <Icon icon={icon} size={size} />
    </span>
  )
}

export default FontAwesomeIcon
